import React from 'react';
import { useEffect,useState } from 'react';
import ExpenseBreakdown from '../components/ExpensesBreakdown';
import HomeChart from '../components/HomeChart';
import ReportTransactionsList from '../components/reports/ReportTransactionsList';
import { 
  Typography, 
  Box
  // Paper, 
  // Table, 
  // TableBody, 
  // TableCell, 
  // TableContainer, 
  // TableHead, 
  // TableRow,
  // Card,
  // CardContent
} from '@mui/material';
import { FinanceData } from '../types';
// import { FinancialRecord } from '../types';

// Sample data for the report
// const sampleData: FinancialRecord[] = [
//   { id: 1, month: 'January', revenue: 5000, expenses: 3200, profit: 1800 },
//   { id: 2, month: 'February', revenue: 6200, expenses: 3800, profit: 2400 },
//   { id: 3, month: 'March', revenue: 7500, expenses: 4100, profit: 3400 },
//   { id: 4, month: 'April', revenue: 8800, expenses: 4700, profit: 4100 },
// ];

       {/* <ExpenseBreakdown financeData={financeData} />
         */}
        {/* <HomeChart
            financeData={financeData}
            updateFinancialData={updateFinancialData}
          />  */}
             {/*  {financeData.expenses && financeData.extraIncome && (<ReportTransactionsList financeData={financeData} />)^}  */}

const Report: React.FC = () => {

    const [loading, setLoading] = useState<boolean>(true);
     const [financeData, setFinanceData] = useState<FinanceData>({
        expectedIncome: 0,
        expectedSavings: 0,
        title: "",
        description: "",
        expenses: [],
        extraIncome: [],
        notes: "",
        startDate: new Date(),
        endDate: new Date(),
      });

   useEffect(() => {
      const loadFinanceData = async () => {
        try {
          const storedData = localStorage.getItem("financeData");
          if (storedData) {
            setFinanceData(JSON.parse(storedData));
          }
        } catch (error) {
          console.error("Error loading finance data:", error);
        } finally {
          setLoading(false);
        }
      };
  
      // Call the async function
      loadFinanceData();
    }, []);

  // Calculate totals
  // const totalRevenue: number = sampleData.reduce((acc, row) => acc + row.revenue, 0);
  // const totalExpenses: number = sampleData.reduce((acc, row) => acc + row.expenses, 0);
  // const totalProfit: number = sampleData.reduce((acc, row) => acc + row.profit, 0);

  return (
    <div id={'report-section'}>
      <Typography variant="h4" component="h1" gutterBottom>
        Financial Report
      </Typography>

      {loading ? <Typography>Loading</Typography> : <>
        <Box>
        <HomeChart
            financeData={financeData}
          /> 
        </Box>
        {financeData.expenses && financeData.extraIncome && (<Box><ReportTransactionsList financeData={financeData} />   </Box>)} 
        

     
          <Box>
            <ExpenseBreakdown financeData={financeData} />
          </Box>
      </>}
      
      {/* <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Summary
          </Typography>
          <Typography variant="body1" data-testid="report-summary">
            This report shows the financial performance for the first quarter of the year.
            Total revenue is ${totalRevenue}, with expenses of ${totalExpenses}, 
            resulting in a profit of ${totalProfit}.
          </Typography>
        </CardContent>
      </Card>
      
      <TableContainer component={Paper}>
        <Table aria-label="financial report table">
          <TableHead>
            <TableRow>
              <TableCell>Month</TableCell>
              <TableCell align="right">Revenue ($)</TableCell>
              <TableCell align="right">Expenses ($)</TableCell>
              <TableCell align="right">Profit ($)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleData.map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.month}
                </TableCell>
                <TableCell align="right">{row.revenue}</TableCell>
                <TableCell align="right">{row.expenses}</TableCell>
                <TableCell align="right">{row.profit}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                Total
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>{totalRevenue}</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>{totalExpenses}</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>{totalProfit}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer> */}
    </div>
  );
};

export default Report;